module.exports = __webpack_public_path__ + "img/t1.4292458f.png";